import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import notFound from '../../assets/notFound.svg';

const PropostaNotFound = () => {

    return (
        <main>
        <Container fluid>
            <div>
                <Row className="justify-content-md-center">
                    <Col  sm={12} md={12} lg={12} className="d-none d-lg-block" style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                        <br></br>
                        <h3>Proposta não encontrada!</h3>
                        <br></br>
                        <img src={notFound} alt="Not Found" style={{width: '365px'}} />
                    </Col>
                </Row>
            </div>
        </Container>
        </main>
    )

}

export default PropostaNotFound;